<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <h2 class="titre">Ajouter Journal</h2>
    </div>
  </div>
  <ModifierChamps ref="modifierChamps" :journal="journal" :isModifier="false"/>
  <ButtonBarJournal @sauvegarder="checkIfLier" @fermer="fermer" :isSauvegardeEnCours="isSauvegardeEnCours"/>
  <DialogConfirmation ref="dialogConfirmation"/>

  <ChoixRole
      :listeRoles="listeRoles"
      v-show="isChoixRoleVisible"
      @fermerChoixRole="fermerChoixRole"
      @lier="lier"
  />
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue';
import ButtonBarJournal from '../../../components/dossier/Ajouter/ButtonBarJournal.vue';
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsJournal.vue';
import ChoixRole from "../../../components/dossier/Liaison/ChoixRole.vue";

export default {
  name: "AjouterJournal",
  components: {
    DialogConfirmation,
    ModifierChamps,
    ButtonBarJournal,
    ChoixRole
  },
  beforeMount() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Ajouter Journal");
    this.$store.dispatch('journal/resetJournalStoredAction');
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      journal: 'journal/journal'
    }),
  },
  data() {
    return {
      isSauvegardeEnCours: false,
      role: null,
      listeRoles: [],
      isChoixRoleVisible: false,
    };
  },
  methods: {
    checkIfLier() {
      if(this.$route.params.isFromLiaison == 'false'){
        this.sauvegarder();
      }else {
        let currentJournal = this.$refs.modifierChamps.getJournalLocal();
        if(currentJournal.dossierVO?.categorie != null) {
          let genre = this.$route.params.genreLiaison
          this.$store
            .dispatch("dossier/obtenirRolesLiaisonAction", {
              moduleSource: genre,
              moduleDestination: "DO",
              categorie: currentJournal.dossierVO.categorie
            })
            .then((res) => {
              this.listeRoles = res.data.sort(this.$commun.compareLibelles);
              if (this.listeRoles.length > 1) {
                this.isChoixRoleVisible = true;
              }else {
                this.role = this.listeRoles.length[0];
                this.sauvegarder();
              }
            });
        }else {
          //role par défaut
          this.role = 875;
          this.sauvegarder();
        }
      }
    },
    lier(role) {
      this.role = role;
      this.sauvegarder();
    },
    sauvegarder() {
      this.isSauvegardeEnCours = true;
      this.isChoixRoleVisible = false;
      this.$store.commit('journal/UPDATE_JOURNAL', this.$refs.modifierChamps.getJournalLocal());
      this.$store.dispatch('journal/ajouterJournalAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
      }).then((res) => {
        if (res?.data?.messages.length == 0) {
          if(this.$route.params.isFromLiaison == 'false') {
            this.$toast.add({
              severity: 'success',
              summary: 'Ajouter',
              detail: 'Le journal a été ajouté.',
              life: 6000
            });
            this.isSauvegardeEnCours = false;
            this.fermer();
          }else {
            let dossier = res.data.entite.dossierVO
            let storeModule;
            if(this.$route.params.genreLiaison == 'SU') {
              storeModule = 'sujet'
            }else if(this.$route.params.genreLiaison == 'SO'){
              storeModule = 'societe'
            }
            this.$store
                .dispatch("dossier/obtenirDossierLieAction", {
                  cleSource: this.$route.params.cleLiaison,
                  siteSource: this.$route.params.siteLiaison,
                  genreSource: this.$route.params.genreLiaison,
                  cleDestination: dossier.cle,
                  siteDestination: dossier.site,
                  role: this.role
                })
                .then((res1) => {
                this.$store.dispatch(storeModule + '/ajouterLiaisonDossierAction', {
                  cle: this.$route.params.cleLiaison,
                  site: this.$route.params.siteLiaison,
                  genre: this.$route.params.genreLiaison,
                  dossierLie: res1.data
                }).then((res) => {
                  if (res.data.length > 0) {
                    this.$emit('addMessage', res.data);
                  } else {
                    this.isSauvegardeEnCours = false;
                    this.fermer();
                    this.$toast.add({
                      severity: 'success',
                      summary: 'Liaison dossier',
                      detail: 'Le dossier a été lié.',
                      life: 6000
                    });
                  }
                })
              })
          }
        } else {
          this.$root.$refs.messagesComp.messagesList = res.data.messages;
          this.isSauvegardeEnCours = false;
        }
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    fermerChoixRole() {
      this.isChoixRoleVisible = false;
    },
  },
  beforeRouteLeave(to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.journal, this.$refs.modifierChamps.getJournalLocal());
  },
}
</script>